/**
 * #981 (spec §8.5, Task 16's client contract): unsaved edits kept on an EARLIER content of the file
 * (the file changed while they were unsaved) are never hidden or dropped silently — this bar offers
 * to save them as a copy (Save As `fromBase`) or to discard them (MSG_DISCARD of that base).
 */
import { useState } from 'react'
import { History } from 'lucide-react'
import { useTranslation } from '@papan/i18n'

export interface LargeCsvStaleEditsBarProps {
  bases: string[]
  busy: boolean
  onSaveCopy: (base: string) => void
  onDiscard: (base: string) => void
}

export function LargeCsvStaleEditsBar({ bases, busy, onSaveCopy, onDiscard }: LargeCsvStaleEditsBarProps) {
  const { t } = useTranslation('collab')
  /** The base whose Discard asks to be confirmed (the same two-step as the toolbar's Discard). */
  const [confirming, setConfirming] = useState<string | null>(null)
  if (!bases.length) return null
  return (
    <div className="border-b themed-border themed-bg-secondary px-4 py-1.5 flex flex-col gap-1 text-xs" role="alert" data-testid="large-csv-stale-edits">
      {bases.map((base) => (
        <div key={base} className="flex items-center gap-2">
          <History size={12} className="themed-text-muted shrink-0" />
          <span className="themed-text flex-1 min-w-0">{t('largeCsv.stale.title')}</span>
          <button className="px-2 py-0.5 rounded themed-btn-secondary" disabled={busy} onClick={() => onSaveCopy(base)} data-testid="large-csv-stale-copy">
            {t('largeCsv.stale.saveCopy')}
          </button>
          <button
            className="px-2 py-0.5 rounded themed-btn-secondary"
            disabled={busy}
            onClick={() => { if (confirming === base) { setConfirming(null); onDiscard(base) } else setConfirming(base) }}
            data-testid="large-csv-stale-discard"
          >
            {confirming === base ? t('largeCsv.stale.confirmDiscard') : t('largeCsv.stale.discard')}
          </button>
        </div>
      ))}
    </div>
  )
}
